import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import get from 'lodash/get';

import BookListItemEmpty from 'rebook/apps/books/components/BookListItemEmpty';
import BookCardHeader from 'rebook/apps/base/components/BookCardHeader';
import BookReviewCitationHeader from 'rebook/apps/books/components/BookReviewCitationHeader';
import * as BookReviewPageAction from 'rebook/apps/books/actions/BookReviewPageAction';
import { Book } from 'rebook/apps/books/models';
import BookReview from 'rebook/apps/books/components/BookReview';


class BookReviewPageView extends React.Component {
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.BookReviewPageAction.fetchInitialData(match, location, true);
  }

  componentDidUpdate(prevProps) {
    const { match, location, bookReview: newBookReview } = this.props;
    const { bookReview } = prevProps;
    if (get(newBookReview, 'review.id', null) !== get(bookReview, 'review.id', null)) {
      this.props.BookReviewPageAction.fetchInitialData(match, location, true);
    }
  }

  componentWillUnmount() {
    this.props.BookReviewPageAction.resetData();
  }

  static fetchInitialDataForServer(match, store) {
    return store.dispatch(BookReviewPageAction.fetchInitialData(match, {}, true));
  }

  render() {
    const { user } = this.props;
    const { review } = this.props.bookReview;
    const theBook = review && new Book(review.book);
    const isAudiobook = get(theBook, 'type', '') === 'audio';

    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          {theBook && (
            <React.Fragment>
              <BookReviewCitationHeader
                title={`Отзыв на ${isAudiobook ? 'аудиокнигу' : 'книгу'}`}
                bookName={theBook.name}
                link={theBook.getLink()} />
              <div className="billetContainer">
                <BookCardHeader withAuthor book={theBook} user={user} theme="grey" withButton GACategory="BookReview" />
                {review === null
                  ? <BookListItemEmpty />
                  : <BookReview review={review} noTruncate isDetailPage />
                }
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    bookReview: state.bookReview,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookReviewPageAction: bindActionCreators(BookReviewPageAction, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookReviewPageView);
